import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles';

export const MuiPaginationItem = (theme: Theme): Components => ({
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 600,
      },
    },
  },
});
